import { NextIntlClientProvider, type AbstractIntlMessages } from 'next-intl';
import { LoginModalHost } from './LoginModalHost';
import { isLocale } from '@/i18n/locales';
import type { LoginQueryRouter } from '@/lib/auth/login-dialog';

/** Static pages ship their own locale's sign-in copy, so opening never awaits a download. */
export function StaticLoginModalHost({ locale: requestedLocale, messages, queryRouter }: {
  locale?: string;
  messages?: AbstractIntlMessages;
  queryRouter?: LoginQueryRouter;
}) {
  const locale = isLocale(requestedLocale) ? requestedLocale : 'en';
  if (!messages) return null;
  return <NextIntlClientProvider locale={locale} messages={messages}>
    <LoginModalHost queryRouter={queryRouter} />
  </NextIntlClientProvider>;
}
